





















































import { message, IMessage, attachments as attachmentsUtility } from "@/utilities/index";
import attachmentCard from "@/Webchat/components/attachments/attachmentCard.vue";
import attachmentsViewer from "@/Webchat/components/attachments/attachmentsViewer.vue";
import cardCarousel from "./cardCarousel.vue";
import buttonTemplate from "./buttonTemplate.vue";
import linkPreview from "./linkPreview.vue";
import 'flickity-imagesloaded';

const urlRegex = /(?:https?:\/\/|www\.)[^\s<]+/gi;
const emailRegex = /(?:[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x21\x23-\x5b]|\\[\x7f])*")@(?:(?:[\w](?:[\w]*[\w])?\.)+[\w](?:[\w]*[\w])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[\w]*[\w]:(?:[\x21-\x5a]|\\[\x7f])+)\])/;
function isEmail(text) {
    return emailRegex.test(text);
}
function extractUrlsAndEmails(text) {
    const parts = [];
    let lastIndex = 0;
    if (!text) return parts;

    const matches = [...text.matchAll(new RegExp(`${urlRegex.source}|${emailRegex.source}`, 'gi'))];

    for (const match of matches) {
        const index = match.index;
        const value = match[0];
        if (index > lastIndex) {
            parts.push(text.slice(lastIndex, index));
        }
        parts.push(value);
        lastIndex = index + value.length;
    }

    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return parts;
}

function detectDirection(text) {
    // Skip emojis and whitespace when detecting direction
    const cleanText = text.trim().replace(/[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]/gu, '').trim();
    // Check if the text contains any Arabic characters
    return /[\u0600-\u06FF]/.test(cleanText) ? 'rtl' : 'ltr';
}

function createEmailLink(email) {
    const a = document.createElement('a');
    a.href = `mailto:${email}`;
    a.textContent = email;
    a.setAttribute('style', 'color: inherit; word-break: break-all; text-decoration: underline;');
    return a;
}
function createUrlLink(url) {
    const a = document.createElement('a');
    a.href = url;
    a.textContent = url;
    a.target = '_blank';
    a.setAttribute('style', 'color: inherit; word-break: break-all; text-decoration: underline;');
    return a;
}

function processTextContent(text) {
    const parts = extractUrlsAndEmails(text);
    const result = document.createDocumentFragment();

    parts.forEach(part => {
        if (urlRegex.test(part)) {
            result.appendChild(createUrlLink(part));
        } else if (isEmail(part)) {
            result.appendChild(createEmailLink(part));
        } else {
            const div = document.createElement('div');
            const lines = part.split('\n');
            lines.forEach((line, i) => {
                if (line.trim()) {
                    const span = document.createElement('span');
                    span.textContent = line;
                    const dir = detectDirection(line);
                    span.setAttribute('dir', dir);
                    span.style.textAlign = dir === 'rtl' ? 'right' : 'left';
                    span.style.unicodeBidi = 'embed';
                    div.appendChild(span);
                }
                if (i < lines.length - 1) {
                    div.appendChild(document.createElement('br'));
                }
            });
            result.appendChild(div);
        }
    });

    return result;
}

function processHTMLNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
        node.replaceWith(processTextContent(node.textContent));
    } else if (node.tagName.toLowerCase() === 'script') {
        node.remove();
        return;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(child => processHTMLNode(child));
    }
}

export default {
    props: {
        message: {
            type: Object,
            required: true,
            default() { return {}; }
        },
        prevMessage: {
            type: Object,
            required: true,
            default() { return {}; }
        },
        isFullScreen: {
            type: Boolean,
            required: false,
            default: false
        },
        selectedLang: {
            type: String,
            required: false,
            default: 'en'
        }
    },
    components: {
        attachmentCard,
        attachmentsViewer,
        cardCarousel,
        buttonTemplate,
        linkPreview
    },
    computed: {
        hasOneAttachment() {
            return this.hasAttachments(this.message) && this.attachments.length === 1;
        },
        messageContentComponents() {
            return this.mapMessageTextToComponents(this.message) || [];
        },
        messageSenderAvatar() {
            const operatorImage = this.$vstore.settings.state.channelSettings.operatorImage;
            return this.message.source?.toLowerCase() === 'bot' ? operatorImage : this.message.sender_picture;
        },
        isValidMessage() {
            return this.message.messaging_type !== 'metadata' && message.isValidMessage(this.message) && ((this.message.text != '' || (this.message.text == '' && this.message.source !== 'bot')));
        }
    },
    data() {
        return {
            showImageViewerOverlay: false,
            attachments: [],
            imagesToPreview: [],
            attachmentIndexToPreview: null,
            copySuccess: '',
            messageId: -1,
            linkTarget: "_blank",
            urlRegex,
            emailRegex
        };
    },
    mounted() {
        this.fetchAttachmentsMetadata();
        this.$emit("mounted");
    },
    methods: {
        detectDirection,
        isProductsList(msg: IMessage) {
            return message.isProductsList(msg);
        },
        isTextButton(msg: IMessage) {
            return message.isTextButton(msg);
        },
        onPostback(payload: any, title: string) {
            this.$emit("onPostback", payload, title);
        },
        disableScrolling() {
            const container = this.$el.querySelector("#webchat-container");
            if (!container) return;
            container.style.overflowY = 'hidden';
        },
        getMessageCardsFromAttachments(message: any) {
            if (message && message.tactfulAttachments.length > 0) {
                return message.tactfulAttachments[0].element;
            }
            return [];
        },
        async fetchAttachmentsMetadata() {
            const attachments = [];
            for (const attachment of (this.message?.tactfulAttachments || [])) {
                if (attachment.type === 'generic' || attachment.type === 'template') continue;
                let metadata = {};
                try {
                    metadata = await attachmentsUtility.getAttachment(attachment) || {};
                } catch {
                    metadata = {};
                }
                attachments.push({ ...attachment, metadata: metadata });
            }
            this.attachments = attachments;
        },
        showAttachment(selectedAttachmentIndex: number) {
            this.attachmentIndexToPreview = selectedAttachmentIndex;
            this.showImageViewerOverlay = true;
            this.imagesToPreview = this.attachments || [];
        },
        downloadAttachment() {
            if (!this.$refs['attachmentCardRef']) return;
            this.$refs['attachmentCardRef'][0]?.downloadAttachment();
        },
        formatMessageDate(time: string) {
            return message.formatMessageDate(time, this.selectedLang);
        },
        isSentByPrevMessageSender(msg: IMessage, prevMessage: IMessage) {
            return message.isSentByPrevMessageSender(msg, prevMessage);
        },
        hasAttachments(message: IMessage) {
            if (!message?.tactfulAttachments?.length) return false;
            return !message.tactfulAttachments.some((attachment) => attachment.type === 'generic' || attachment.type === 'template');
        },
        extractUrlFromMessage(message: any) {//extract urls from text and return them if exist
            if (this.urlRegex.test(message)) {
                // check first if its' not an email (we DON'T want to preview the email as a LINK)
                if (!this.emailRegex.test(message)) {
                    const matches = message.match(this.urlRegex);
                    if (matches && matches.length > 0) {
                        return matches[0];
                    }
                    return null;
                } else {
                    return null;
                }
            } else {
                return null;
            }

        },
        getFormattedMessage(msg: IMessage) {
            return this.isTextButton(msg) ? msg.attachment.payload.text : this.formatMsg(msg.text);
        },
        formatMsg(msg: string) {
            if (!msg?.trim()) return '';
            const parser = new DOMParser();
            const doc = parser.parseFromString(msg, 'text/html');

            Array.from(doc.body.childNodes).forEach(node => processHTMLNode(node));
            return doc.body.innerHTML;
        }
    }
};
